import { useMemo, useState } from 'react'

import { FileAccessGrantAccessor, RecipientsSelectorValueType } from 'types'
import { useGroupMembers } from 'hooks/queries/groups/useGroupMembers'

export const useExpandGroupRow = ({
  groupId,
  childMembers,
  type,
}: {
  type: RecipientsSelectorValueType
  groupId?: number
  childMembers?: FileAccessGrantAccessor[]
}) => {
  const [expanded, setExpanded] = useState(false)
  const { data } = useGroupMembers({ groupId, enabled: expanded })

  const childRows = useMemo(() => {
    if (!!childMembers?.length) return childMembers
    if (!data) return []

    return data.map((membership) => {
      const { id, display_name, avatar_url } = membership.member

      return { id, name: display_name, type: 'User', avatar_url } as FileAccessGrantAccessor
    })
  }, [data, childMembers])

  const toggleExpanded = () => {
    if (
      ![
        RecipientsSelectorValueType.Channel,
        RecipientsSelectorValueType.LayerEditors,
        RecipientsSelectorValueType.Company,
      ].includes(type)
    )
      return

    setExpanded((prev) => !prev)
  }

  return { expanded, toggleExpanded, childRows }
}
